import { X } from "lucide-react";

export function PhoneDamageMarker({ marques, onChange, label, disabled }) {
  const points = marques || [];

  const handleClick = (e) => {
    if (disabled) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    onChange([...points, { x, y }]);
  };

  const removeMark = (idx, e) => {
    e.stopPropagation();
    if (disabled) return;
    onChange(points.filter((_, i) => i !== idx));
  };

  return (
    <div className="flex flex-col items-center gap-1.5">
      <p className="text-xs font-medium text-muted-foreground">{label}</p>
      <div
        onClick={handleClick}
        className={`relative w-28 h-56 rounded-2xl border-2 border-border bg-secondary/30 ${disabled ? "" : "cursor-crosshair"}`}
        data-testid={`phone-damage-${label}`}
      >
        {points.map((m, i) => (
          <button
            key={i} type="button" onClick={(e) => removeMark(i, e)}
            className="absolute w-5 h-5 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center"
            style={{ left: `${m.x}%`, top: `${m.y}%` }}
            title="Cliquer pour retirer" data-testid={`phone-damage-${label}-mark-${i}`}
          >
            <X size={16} className="text-destructive" strokeWidth={3} />
          </button>
        ))}
      </div>
      {!disabled && <p className="text-[10px] text-muted-foreground">Toucher pour marquer un dommage</p>}
    </div>
  );
}
